var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldUserAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.91 22.5c0 .28.22.5.5.5h17.18c.28 0 .5-.22.5-.5 0-4.14-4.08-7.5-9.09-7.5s-9.09 3.36-9.09 7.5z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2c-1.4 0-2.68.57-3.59 1.51C7.54 4.41 7 5.65 7 7c0 .94.26 1.82.73 2.57.25.43.57.82.95 1.14.87.8 2.03 1.29 3.32 1.29 1.83 0 3.41-.98 4.28-2.43.26-.43.46-.91.57-1.41.1-.37.15-.76.15-1.16 0-1.28-.49-2.45-1.29-3.34A4.948 4.948 0 0 0 12 2zm.94 5.92v.97a.939.939 0 1 1-1.88 0v-.97h-.93a.939.939 0 1 1 0-1.88h.93v-.89a.939.939 0 1 1 1.88 0v.89h.93a.939.939 0 1 1 0 1.88h-.93z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldUserAdd);
export default __webpack_public_path__ + "static/media/vuesax-bold-user-add.9d74f1cdd54c54c81fbd51055cb10467.svg";
export { ForwardRef as ReactComponent };